import React from 'react';

import { OperationClientUsage } from 'src/components/operationClientUsage/OperationClientUsage';
import { date } from 'src/lib/date/date';
import { GraphQLTypes } from 'src/lib/graphqlTypes';

type OperationOverviewSectionProps = {
  graphId: string;
  graphVariant?: string;
  range: Parameters<typeof date.getDateBounds>[0];
  queryId?: string;
  filter:
    | GraphQLTypes.ServiceErrorStatsFilter
    | GraphQLTypes.ServiceTracePathErrorsRefsFilter
    | GraphQLTypes.ServiceTraceRefsFilter
    | GraphQLTypes.ServiceQueryStatsFilter;
};

export function OperationOverviewSection(props: OperationOverviewSectionProps) {
  const { graphId, graphVariant, queryId, range, filter } = props;

  return (
    <>
      {graphVariant && queryId ? (
        <OperationClientUsage
          range={range}
          graphId={graphId}
          graphVariant={graphVariant}
          queryId={queryId}
          filter={filter}
        />
      ) : null}
    </>
  );
}
